import * as React from 'react';
import styled from 'styled-components';

import colors from '../../colors';
import Divider from '../../Shared/Divider';
import { default as BaseSurvey, BaseProps, BaseState } from '../BaseSurvey';
import { surveyAnimation } from '../../../util/styles';

export default class Survey extends BaseSurvey<BaseProps, BaseState> {
    public render() {
        return (
            <Wrapper className="conversations-survey">
                <Divider />
                <Title>How would you rate your conversation with {this.props.name}?</Title>
                {this.renderFaces()}
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`
    margin-bottom: 15px;
    ${surveyAnimation};
`;

const Title = styled.h3`color: ${colors.black} !important;`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Sidebar/Survey.tsx